import { Injectable } from '@angular/core';
import { ConsentService } from './consent.service';

const CLARITY_PROJECT_ID = 'yzca5yzy9l';

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[] };

@Injectable({ providedIn: 'root' })
export class ClarityService {
  private started = false;

  constructor(private readonly consent: ConsentService) {}

  start(): void {
    if (this.started || !this.consent.hasConsent() || typeof document === 'undefined') {
      return;
    }
    this.started = true;
    const w = window as Window & { clarity?: ClarityFn };
    if (typeof w.clarity !== 'function') {
      const clarity: ClarityFn = function (...args: unknown[]) {
        (clarity.q = clarity.q || []).push(args);
      };
      w.clarity = clarity;
    }
    if (document.querySelector('script[src*="www.clarity.ms/tag/"]')) {
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}?ref=bwt`;
    const first = document.getElementsByTagName('script')[0];
    if (first?.parentNode) {
      first.parentNode.insertBefore(script, first);
      return;
    }
    document.head.appendChild(script);
  }
}
